import { useEffect, useState } from "react";

import { RichTextEditor } from "../../../../../../../components/RichTextEditor";
import { FormAnswerField } from "./InformativeQuestionDisplay.styles";

interface IInformativeQuestionDisplayProps {
  HTMLText: string;
  isForms?: boolean;
}

export function InformativeQuestionDisplay({
  HTMLText,
  isForms,
}: IInformativeQuestionDisplayProps) {
  const [value, setValue] = useState<string>("");
  const [heigth, setHeight] = useState<number>(0);

  useEffect(() => {
    setValue(HTMLText);
    const parentDivHeight = document.documentElement.clientHeight;
    setHeight(parentDivHeight ? parentDivHeight - 225 : 0);
  }, []);

  return (
    <FormAnswerField id="parentDiv" isForms={isForms}>
      <RichTextEditor
        height={heigth}
        mobile
        readOnly
        value={value}
        onValueChange={() => {}}
      />
    </FormAnswerField>
  );
}
